import { render } from "./InstagramLogo.vue?vue&type=template&id=d6cbeb88&scoped=true"
import script from "./InstagramLogo.vue?vue&type=script&lang=js"
export * from "./InstagramLogo.vue?vue&type=script&lang=js"

import "./InstagramLogo.vue?vue&type=style&index=0&id=d6cbeb88&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6cbeb88"]])

export default __exports__